import { Component, Host, h, Prop, Listen, Element } from '@stencil/core';

import axios from '../../../utils/get-axios';
import { LiluModal } from '../../03_organisms/lilu-modal/lilu-modal';
const ACC = (window as any).ACC;

@Component({
  tag: 'lilu-modal-link',
  styleUrl: 'lilu-modal-link.scss',
  shadow: true,
})
export class LiluModalLink {
  @Prop() dataAxiosUrl: string;
  @Prop() dataProductId = '';
  @Prop() width: '' | 'fit' = '';
  @Prop() float: '' | 'right' = '';
  @Prop() dataModalShow: string;
  @Prop() modalFromHashLoaded = false;
  @Prop() isClosable = true;
  @Element() el: HTMLElement;

  modal: LiluModal;
  modalContent: HTMLElement;
  urlHash: string;

  componentWillLoad() {
    this.modal = document.querySelector(`[data-modal="default"]`) as any as LiluModal;
    this.modalContent = document.querySelector(`[data-modal="default"] .content`);
    this.urlHash = window.location.hash.toLowerCase().replace('#modal:', '');
    if (!this.modalFromHashLoaded && this.urlHash !== null && this.urlHash !== '' && this.urlHash === this.dataModalShow) {
      this.modalFromHashLoaded = true;
      this.onHashValueOpenModal();
    }
  }

  @Listen('click')
  handleModal(e) {
    e.preventDefault();

    if (this.modalContent !== null) {
      this.modalContent.innerHTML = '';
    }

    if (this.dataAxiosUrl !== undefined && this.dataAxiosUrl !== '') {
      let data: any = {};
      data = this.serializeParametersInputs(e.target);

      axios
        .post(this.dataAxiosUrl, data, {
          headers: {
            CSRFToken: ACC.config.CSRFToken,
          },
        })
        .then(response => {
          if (response.data.content === undefined) {
            this.modalContent.innerHTML = response.data.html;
          } else {
            this.modalContent.innerHTML = response.data.content;
          }
          const isLogin = this.modalContent.innerHTML.indexOf('lilu-login') >= 0;
          this.modal.open(this.dataProductId, this.isClosable, isLogin);
        });
    }
  }

  onHashValueOpenModal() {
    let hiddenFields = {};
    let data;

    this.el.querySelectorAll('input').forEach(inputField => {
      if ('hidden' === inputField.type) {
        hiddenFields[inputField.name] = inputField.value;
      }
    });

    if (Object.keys(hiddenFields).length > 0) {
      data = hiddenFields;
    } else {
      data = '';
    }

    axios
      .post(this.dataAxiosUrl, data, {
        headers: {
          CSRFToken: ACC.config.CSRFToken,
        },
      })
      .then(response => {
        this.modalContent.innerHTML = response.data.content;
        const isLogin = response.data.content.indexOf('lilu-login') >= 0;
        this.modal.open('', this.isClosable, isLogin);
      });
  }

  serializeParametersInputs(element) {
    const parent = element.closest('lilu-modal-link');
    const inputs = parent.querySelectorAll('input[type=hidden]');
    let parameters: any = {};

    inputs.forEach(input => {
      const name = input.getAttribute('name');
      const value = input.getAttribute('value');

      parameters[name] = value;
    });
    return parameters;
  }

  render() {
    return (
      <Host>
        <div class={`${this.width} ${this.float}`}>
          <slot name="input"></slot>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
